import { Navigate, Outlet } from 'react-router-dom'

import { possuiPapel } from '@/lib/auth/roles'
import { useAuthStore } from '@/stores/authStore'

/** Nested dentro de <ProtectedRoute>: exige pelo menos um dos papéis. */
export function RequireRole({ roles }: { roles: readonly string[] }) {
  const papeis = useAuthStore((state) => state.user?.papeis)

  if (!possuiPapel(papeis, roles)) {
    return <Navigate to="/403" replace />
  }

  return <Outlet />
}
